/**
 * MagnetFooter — the counterpart to MagnetHeader: the one piece of EE chrome
 * sanctioned BELOW a full-document magnet body (see MagnetPage.tsx +
 * sop-ee-lead-magnets.md).
 *
 * Same rendering constraint as MagnetHeader — full-doc bodies are CC's own
 * complete HTML documents injected via dangerouslySetInnerHTML, so this
 * footer renders as a SIBLING below that injected div and must use inline
 * styles exclusively.
 *
 * Closes a real gap, not just a cosmetic one: full-doc magnets bypass
 * TakerShell/TakerFooter entirely (by design — see MagnetPage.tsx), which
 * means they previously carried no Privacy Policy / Terms links anywhere on
 * the page despite running paid traffic and collecting an email address in
 * the capture form. PolicyLinks is the same component every other EE public
 * page uses for this — see its own file header for the compliance rationale
 * (ad-platform destination requirements, GDPR/CCPA/CASL).
 */

import { PolicyLinks } from './PolicyLinks';
import type { MagnetHeaderBrand } from './MagnetHeader';

const TSB_DEFAULT_HREF = 'https://www.thesuccessfulbookkeeper.com';

export default function MagnetFooter({ brand }: { brand: MagnetHeaderBrand | null }) {
  return (
    <footer
      style={{
        background: '#0A0A2E',
        color: 'rgba(255,255,255,0.75)',
        fontSize: 12.5,
        fontWeight: 500,
        padding: '18px 28px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 10,
      }}
    >
      <span>
        &copy; {new Date().getFullYear()} {brand?.name ?? 'The Successful Bookkeeper'}
      </span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        <a
          href={brand?.logoLinkUrl ?? TSB_DEFAULT_HREF}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,255,255,0.75)', textDecoration: 'none' }}
        >
          {(brand?.logoLinkUrl ?? TSB_DEFAULT_HREF).replace(/^https?:\/\//, '')}
        </a>
        <span aria-hidden="true">&nbsp;&middot;&nbsp;</span>
        <PolicyLinks color="rgba(255,255,255,0.75)" />
      </span>
    </footer>
  );
}
